// extracted by mini-css-extract-plugin
export default {"-large":"jeIBopQffceE8G1XF1uU","skeletonItem":"ULUKJjA5XQdV5LMV40A0","changeColorLight":"Bc53CKFhiyX7aqeTXplm"};